import type { StyleValue } from "@circle-react-shared/BuilderUI/StyleValue.types";

export const processUnitValue = (
  styleValue: StyleValue,
  defaultUnit: string,
): string | undefined => {
  if (styleValue.value === undefined || styleValue.value === null) {
    return undefined;
  }

  const unit = styleValue.meta?.unit ?? defaultUnit;

  if (typeof styleValue.value === "string") {
    return styleValue.value;
  }

  return `${String(styleValue.value)}${unit}`;
};
